import { HttpException } from './HttpException';

export class SurveyClosedException extends HttpException {
  static readonly API_CODE = 'PROJECT_CLOSED';

  constructor(message: string, httpCode?: number) {
    super(message, httpCode);

    Object.setPrototypeOf(this, SurveyClosedException.prototype);
  }

  getApiCode(): string {
    return SurveyClosedException.API_CODE;
  }
}
